import { render, staticRenderFns } from "./crash.vue?vue&type=template&id=f738765a&"
import script from "./crash.vue?vue&type=script&lang=js&"
export * from "./crash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports